/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

import AccountService from 'cio/services/account';
import MailServerModel from 'cio/models/mail-server';

interface ServersTableArgs {
  servers: MailServerModel[];
  onAdd: () => unknown;
  onDelete: (server: MailServerModel) => unknown;
  onEdit: (server: MailServerModel) => unknown;
}

export default class ServersTable extends Component<ServersTableArgs> {
  @service account!: AccountService;

  sendingAirplaneImage = new URL('cio/assets/images/sending-airplane.svg', import.meta.url).toString();
}
